import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '@dental-ui/auth';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const portalAdminGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  const user = authState.user();
  const isLoading = authState.isLoading();

  // Kullanıcı yüklendi ve admin
  if (user?.isAdmin === true) {
    return true;
  }

  // Auth/Me çağrısı devam ediyor (isLoading = true):
  // persistAuthParamsFromUrl geçici user set eder (isAdmin yok), refreshSession başlatır.
  // isLoading false olana kadar bekle, sonra tekrar kontrol et.
  if (isLoading) {
    return toObservable(authState.isLoading).pipe(
      filter((loading) => !loading),
      take(1),
      map(() => (authState.user()?.isAdmin === true ? true : router.parseUrl('/not-authorized'))),
    );
  }

  // Auth tamamlandı, kullanıcı admin değil
  return router.parseUrl('/not-authorized');
};
